import {makeStyles} from "@mui/styles";
import Button from "@mui/material/Button";
import {Box, Grid, Paper} from "@mui/material";
import { Container, Row, Col, Ratio } from "react-bootstrap";
import t from "../../../Utils/Translation";
import LykioButton from "../../common/LykioButton";
import React, {useState} from "react";
import {styled} from "@mui/material/styles";
import ResultChoices from "./ResultChoices";

const LykioCustomButton = styled(Button)(() => ({
    background: "linear-gradient(to bottom, #006f4b, #006f4b)",
    color: "white",
    borderColor: "#c4c5c7",
    '&:hover': {
        background: "white",
        color: "#006f4b",
        borderStyle: 'solid !important',
        borderWidth: '0.2em',
        borderRadius: '7px',
        borderColor: "#006f4b"
    },
}));
const Feedback = ({candidatesResults, setIsBackClicked, setCurrentStep }) => {

    const [confirm, setConfirm] = useState(false)


    const handleConfirm = () => {
        setConfirm(true)
    }
    const handleBackClick = () => {
        setCurrentStep(3)
        setIsBackClicked(true)
    }

    return (
        <div className="lykiocss-center margin lykiocss-margin-top-4em" style={{ color: 'black' }}>
    <Container>
    <div style={{display:'flex', justifyContent: 'center'}}>

        {candidatesResults.candidateChoice === candidatesResults.correctCandidateChoice ? (
                <Container className="lykiocss-margin-top-2em">
                    <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                        <div style={{background: "#006f4b", textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">
                            {t('Excellent decision: Giulia is the candidate who best fits the required profile.')}
                        </div>
                    </Row>
                </Container>
        ) : (
            <Container className="lykiocss-margin-top-2em">
                <Row className="lykiocss-center" style={{marginBottom:'2em'}}>
                    <div style={{background: "#006f4b", textAlign:'center', color: 'white', padding: '1em', fontSize:'21px', borderRadius:'0.3em', maxWidth:'40em'}} className="lykiocss-center">
                        {t('You may have been influenced by some bias in your decision. Do you confirm your choice, or do you want to listen to the three presentations again?')}
                    </div>
                </Row>
            </Container>
        )}
  </div>
        {!confirm && (
            <div className="lykiocss-center" style={{gap: '20px'}}>
                {/* <div className="col-4 text-center">
                    <LykioCustomButton style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} className="lykiocss-margin-top-2em" >{t('Back To Videos')}</LykioCustomButton>
                </div> */}
                <LykioCustomButton style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} onClick={handleBackClick} className="lykiocss-margin-top-2em" >{t('PRESENTATIONS')}</LykioCustomButton>
                {/*<div className="col-4 text-center">*/}
                {/*    <LykioCustomButton style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} onClick={handleConfirm} className="lykiocss-margin-top-2em" >{t('Conferma')}</LykioCustomButton>*/}
                {/*</div>*/}
                <div className="col-4 text-center">
                    <LykioCustomButton style={{maxWidth:'20em', fontSize: '21px', padding:'0.5em', paddingLeft:'2em', paddingRight:'2em'}} onClick={handleConfirm} className="lykiocss-margin-top-2em" >{t('Confirm')}</LykioCustomButton>
                </div>
            </div>
        )}

        {confirm && (
            <ResultChoices candidatesResults={candidatesResults} setIsBackClicked={setIsBackClicked} setCurrentStep={setCurrentStep} />
        )}

    </Container>
  </div>
    );
}

export default  Feedback